export default "__VITE_ASSET__l9ScN$IQ__"